<div>
    <div style="margin-left: 65%; margin-bottom: 2%">
        <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger noPrint"
            (click)="exportexcel('Print_Order')">Export</button>
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Label" printSectionId="print-section" ngxPrint>
            Print
        </button>
        <button class="noPrint" style="margin-right: 2%" mat-raised-button color="primary" (click)="save()">
            Save
        </button>
        <!-- mat-dialog-close -->
        <button (click)="closeDialog()" class="btn noPrint">Close</button>
    </div>

<div style="padding-left: 0%; padding-right: 0%; font-weight: 600;">
    <table class="table table-striped text-center">
        <tr style="width: 100%;">
            <td colspan="7" style="border-width: 2px 2px 0 2px; width: 70%; font-size: 20px;"><span class="fontBold">सा. विवेक -
                    अंक
                    छपाई आदेश</span></td>
            <td colspan="3" style="border-width: 2px 2px 0 0; width: 30%;">दिनांक : {{ today | date:'dd-MM-yyyy'
                }}</td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 2px 2px 0 2px; width: 50%; font-size: 20px;">आदेश क्र : {{weeksCount}}</td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 30%;">पृष्ठ क्रं.</td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">पृष्ठ संख्या</td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">प्रकार</td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">पाने देणार</td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 2px 2px 0 2px; width: 50%; font-size: 18px;">अंक दिनांक : {{ startDate  }} ते {{ endDate  }}</td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[0]['prushta_kr'] }}"
                    (change)="addTempData($event, 0, 'prushta_kr')">
                <!-- <span *ngIf="tempData[0]['prushta_kr'] !== ''">{{ tempData[0]['prushta_kr'] }}</span>
                        <span *ngIf="tempData[0]['prushta_kr'] == ''"><input type="text"
                                value="{{ tempData[0]['prushta_kr'] }}"
                                (change)="addTempData($event, 0, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="number" value="{{ tempData[0]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 0, 'prushta_sankhya')">
                <!-- <span *ngIf="tempData[0]['prushta_sankhya'] !== ''">{{ tempData[0]['prushta_sankhya'] }}</span>
                        <span *ngIf="tempData[0]['prushta_sankhya'] == ''">
                            <input type="number" value="{{ tempData[0]['prushta_sankhya'] }}"
                                (change)="addTempData($event, 0, 'prushta_sankhya')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[0]['prakar'] }}" (change)="addTempData($event, 0, 'prakar')">
                <!-- <span *ngIf="tempData[0]['prakar'] !== ''">{{
                            tempData[0]['prakar'] }}</span>
                        <span *ngIf="tempData[0]['prakar'] == ''"><input type="text" value="{{ tempData[0]['prakar'] }}"
                                (change)="addTempData($event, 0, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[0]['pane_denar'] }}"
                    (change)="addTempData($event, 0, 'pane_denar')">
                <!-- <span *ngIf="tempData[0]['pane_denar'] !== ''">{{
                            tempData[0]['pane_denar'] }}</span>
                        <span *ngIf="tempData[0]['pane_denar'] == ''"><input type="text"
                                value="{{ tempData[0]['pane_denar'] }}"
                                (change)="addTempData($event, 0, 'pane_denar')"></span> -->
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%; font-size: 18px;">च्या अंकाकरिता</td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[1]['prushta_kr'] }}"
                    (change)="addTempData($event, 1, 'prushta_kr')">
                <!-- <span *ngIf="tempData[1]['prushta_kr'] !== ''">{{ tempData[1]['prushta_kr'] }}</span>
                        <span *ngIf="tempData[1]['prushta_kr'] == ''"><input type="text"
                                value="{{ tempData[1]['prushta_kr'] }}"
                                (change)="addTempData($event, 1, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <!-- <span *ngIf="tempData[1]['prushta_sankhya'] !== ''">{{ tempData[1]['prushta_sankhya'] }}</span>
                        <span *ngIf="tempData[1]['prushta_sankhya'] == ''">
                            <input type="number" value="{{ tempData[1]['prushta_sankhya'] }}"
                                (change)="addTempData($event, 1, 'prushta_sankhya')"></span> -->
                <input type="number" value="{{ tempData[1]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 1, 'prushta_sankhya')">
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[1]['prakar'] }}" (change)="addTempData($event, 1, 'prakar')">
                <!-- <span *ngIf="tempData[1]['prakar'] !== ''">{{
                            tempData[1]['prakar']
                            }}</span>
                        <span *ngIf="tempData[1]['prakar'] == ''"><input type="text" value="{{ tempData[1]['prakar'] }}"
                                (change)="addTempData($event, 1, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[1]['pane_denar'] }}"
                    (change)="addTempData($event, 1, 'pane_denar')">
                <!-- <span *ngIf="tempData[1]['pane_denar'] !== ''">{{
                            tempData[1]['pane_denar'] }}</span>
                        <span *ngIf="tempData[1]['pane_denar'] == ''"><input type="text"
                                value="{{ tempData[1]['pane_denar'] }}"
                                (change)="addTempData($event, 1, 'pane_denar')"></span> -->
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[2]['prushta_kr'] }}"
                    (change)="addTempData($event, 2, 'prushta_kr')">
                <!-- <span *ngIf="tempData[2]['prushta_kr'] !== ''">{{ tempData[2]['prushta_kr'] }}</span>
                        <span *ngIf="tempData[2]['prushta_kr'] == ''"><input type="text"
                                value="{{ tempData[2]['prushta_kr'] }}"
                                (change)="addTempData($event, 2, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="number" value="{{ tempData[2]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 2, 'prushta_sankhya')">
                <!-- <span *ngIf="tempData[2]['prushta_sankhya'] !== ''">{{ tempData[2]['prushta_sankhya'] }}</span>
                        <span *ngIf="tempData[2]['prushta_sankhya'] == ''">
                            <input type="number" value="{{ tempData[2]['prushta_sankhya'] }}"
                                (change)="addTempData($event, 2, 'prushta_sankhya')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[2]['prakar'] }}" (change)="addTempData($event, 2, 'prakar')">
                <!-- <span *ngIf="tempData[2]['prakar'] !== ''">{{
                            tempData[2]['prakar']
                            }}</span>
                        <span *ngIf="tempData[2]['prakar'] == ''"><input type="text" value="{{ tempData[2]['prakar'] }}"
                                (change)="addTempData($event, 2, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[2]['pane_denar'] }}"
                    (change)="addTempData($event, 2, 'pane_denar')">
                <!-- <span *ngIf="tempData[2]['pane_denar'] !== ''">{{
                            tempData[2]['pane_denar'] }}</span>
                        <span *ngIf="tempData[2]['pane_denar'] == ''"><input type="text"
                                value="{{ tempData[2]['pane_denar'] }}"
                                (change)="addTempData($event, 2, 'pane_denar')"></span> -->
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 2px 2px 0 2px; width: 50%;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[3]['prushta_kr'] }}"
                    (change)="addTempData($event, 3, 'prushta_kr')">
                <!-- <span *ngIf="tempData[3]['prushta_kr'] !== ''">{{ tempData[3]['prushta_kr'] }}</span>
                        <span *ngIf="tempData[3]['prushta_kr'] == ''"><input type="text"
                                value="{{ tempData[3]['prushta_kr'] }}"
                                (change)="addTempData($event, 3, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="number" value="{{ tempData[3]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 3, 'prushta_sankhya')">
                <!-- <span *ngIf="tempData[3]['prushta_sankhya'] !== ''">{{ tempData[3]['prushta_sankhya'] }}</span>
                        <span *ngIf="tempData[3]['prushta_sankhya'] == ''">
                            <input type="number" value="{{ tempData[3]['prushta_sankhya'] }}"
                                (change)="addTempData($event, 3, 'prushta_sankhya')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[3]['prakar'] }}" (change)="addTempData($event, 3, 'prakar')">
                <!-- <span *ngIf="tempData[3]['prakar'] !== ''">{{
                            tempData[3]['prakar']
                            }}</span>
                        <span *ngIf="tempData[3]['prakar'] == ''"><input type="text" value="{{ tempData[3]['prakar'] }}"
                                (change)="addTempData($event, 3, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[3]['pane_denar'] }}"
                    (change)="addTempData($event, 3, 'pane_denar')">
                <!-- <span *ngIf="tempData[3]['pane_denar'] !== ''">{{
                            tempData[3]['pane_denar'] }}</span>
                        <span *ngIf="tempData[3]['pane_denar'] == ''"><input type="text"
                                value="{{ tempData[3]['pane_denar'] }}"
                                (change)="addTempData($event, 3, 'pane_denar')"></span> -->
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[4]['prushta_kr'] }}"
                    (change)="addTempData($event, 4, 'prushta_kr')">
                <!-- <span *ngIf="tempData[4]['prushta_kr'] !== ''">{{ tempData[4]['prushta_kr'] }}</span>
                        <span *ngIf="tempData[4]['prushta_kr'] == ''"><input type="text"
                                value="{{ tempData[4]['prushta_kr'] }}"
                                (change)="addTempData($event, 4, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="number" value="{{ tempData[4]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 4, 'prushta_sankhya')">
                <!-- <span *ngIf="tempData[4]['prushta_sankhya'] !== ''">{{ tempData[4]['prushta_sankhya'] }}</span>
                        <span *ngIf="tempData[4]['prushta_sankhya'] == ''">
                            <input type="number" value="{{ tempData[4]['prushta_sankhya'] }}"
                                (change)="addTempData($event, 4, 'prushta_sankhya')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[4]['prakar'] }}" (change)="addTempData($event, 4, 'prakar')">
                <!-- <span *ngIf="tempData[4]['prakar'] !== ''">{{
                            tempData[4]['prakar']
                            }}</span>
                        <span *ngIf="tempData[4]['prakar'] == ''"><input type="text" value="{{ tempData[4]['prakar'] }}"
                                (change)="addTempData($event, 4, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[4]['pane_denar'] }}"
                    (change)="addTempData($event, 4, 'pane_denar')">
                <!-- <span *ngIf="tempData[4]['pane_denar'] !== ''">{{
                            tempData[4]['pane_denar'] }}</span>
                        <span *ngIf="tempData[4]['pane_denar'] == ''"><input type="text"
                                value="{{ tempData[4]['pane_denar'] }}"
                                (change)="addTempData($event, 4, 'pane_denar')"></span> -->
            </td>
        </tr>
        <!-- Empty Tab Show  -->
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">
                <input type="text" value="{{ tempData[5]['prushta_kr'] }}" (change)="addTempData($event, 5, 'prushta_kr')">
                <!-- <span *ngIf="tempData[4]['prushta_kr'] !== ''">{{ tempData[4]['prushta_kr'] }}</span>
                                <span *ngIf="tempData[4]['prushta_kr'] == ''"><input type="text"
                                        value="{{ tempData[4]['prushta_kr'] }}"
                                        (change)="addTempData($event, 4, 'prushta_kr')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="number" value="{{ tempData[5]['prushta_sankhya'] }}"
                    (change)="addTempData($event, 5, 'prushta_sankhya')">
                <!-- <span *ngIf="tempData[4]['prushta_sankhya'] !== ''">{{ tempData[4]['prushta_sankhya'] }}</span>
                                <span *ngIf="tempData[4]['prushta_sankhya'] == ''">
                                    <input type="number" value="{{ tempData[4]['prushta_sankhya'] }}"
                                        (change)="addTempData($event, 4, 'prushta_sankhya')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[5]['prakar'] }}" (change)="addTempData($event, 5, 'prakar')">
                <!-- <span *ngIf="tempData[4]['prakar'] !== ''">{{
                                    tempData[4]['prakar']
                                    }}</span>
                                <span *ngIf="tempData[4]['prakar'] == ''"><input type="text" value="{{ tempData[4]['prakar'] }}"
                                        (change)="addTempData($event, 4, 'prakar')"></span> -->
            </td>
            <td style="border-width: 2px 2px 0 0; width: 10%;">
                <input type="text" value="{{ tempData[5]['pane_denar'] }}" (change)="addTempData($event, 5, 'pane_denar')">
                <!-- <span *ngIf="tempData[4]['pane_denar'] !== ''">{{
                                    tempData[4]['pane_denar'] }}</span>
                                <span *ngIf="tempData[4]['pane_denar'] == ''"><input type="text"
                                        value="{{ tempData[4]['pane_denar'] }}"
                                        (change)="addTempData($event, 4, 'pane_denar')"></span> -->
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%; font-size: 20px;">एकूण प्रती : {{ total }}</td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;"></td>
            <td style="border-width: 2px 2px 0 0; width: 10%;"></td>
            <td style="border-width: 2px 2px 0 0; width: 10%;"></td>
            <td style="border-width: 2px 2px 0 0; width: 10%;"></td>
        </tr>
        <tr>
            <td colspan="5" style="border-width: 0 2px 0 2px; width: 50%;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0;width: 20%;">एकूण पृष्ठ :</td>
            <td style="border-width: 2px 2px 0 0; width: 10%; text-align: right;">{{ totalpsankhya }}</td>
            <td style="border-width: 2px 2px 0 0; width: 10%;"></td>
            <td style="border-width: 2px 2px 0 0; width: 10%;"></td>
        </tr>
        <tr>
            <td colspan="1" style="border-width: 2px 2px 0 2px; width: 5%; text-align: center;">क्रमांक</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;">विगत</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;">प्रती</td>
            <td colspan="5" style="border-width: 2px 2px 0 0;width: 55%;">शेरा</td>
            <!-- <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;"></td> -->
        </tr>
        <tr *ngFor="let item of tempdata;let i=index;let e=last">
            <td colspan="1" style="border-width: 2px 2px 0 2px; width: 5%; text-align: center;">{{ item['no'] }}</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%; text-align: left;">
                <span *ngIf="item['name'] !== ''">{{ item['name'] }}</span>
                <span style="float: right;" *ngIf="item['name'] == ''"><input type="text" value="{{ item['name'] }}"
                        (change)="addtempdata($event, i, 'name')"></span>
            </td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%; text-align: right;">
                <span *ngIf="item['prati'] !== 0">{{item['prati'] }}</span>
                <span *ngIf="item['prati'] == 0"><input type="text" value="{{ item['prati'] }}"
                        (change)="addtempdata($event, i, 'prati')"></span>
            </td>
            <td colspan="5" style="border-width: 2px 2px 0 0;width: 55%;">
                <span *ngIf="e"><button mat-raised-button class="btn btn-outline-info"
                        (click)="addNewtempdata()">Add</button></span>
            </td>
            <!-- <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;">
                <span *ngIf="e"><button mat-raised-button class="btn btn-outline-info"
                        (click)="addNewtempdata()">Add</button></span>
            </td> -->
        </tr>
        <tr>
            <td colspan="1" style="border-width: 2px 2px 0 2px; width: 5%;"></td>
            <td colspan="2" class="totalRow" style="border-width: 2px 2px 0 0; width: 20%; font-size: 20px; font-weight: bold;">एकूण</td>
            <td colspan="2" class="totalRow" style="border-width: 2px 2px 0 0; width: 20%; font-size: 20px; font-weight: bold; text-align: right;">{{ total }}</td>
            <td colspan="5" style="border-width: 2px 2px 0 0;width: 55%;"></td>
            <!-- <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;"></td> -->
        </tr>
        <tr>
            <td colspan="12"
                style="border-width: 2px 2px 0 2px; width: 100%;padding: 1%; text-align: end;padding-top: 5%; height: 100px; vertical-align: bottom;">
                वर्गणी विभाग
            </td>
        </tr>

        <!-- <tr>
            <td colspan="12" style="border-width: 2px 2px 0 2px; width: 100%; padding-top: 5%; height: 30px;"></td>
        </tr> -->
        
        <tr>
            <td colspan="12" style="border-width: 2px 2px 0 2px; padding: 0.5%; text-align: center; width: 100%; font-size: 18px;">
                पेपर तपशिल</td>
        </tr>
        <tr>
            <td colspan="3" style="border-width: 2px 2px 0 2px; width: 5%;">पेपर प्रकार</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%;">मागील शिल्लक <br> पेपर रीम</td>
            <td colspan="1" style="border-width: 2px 2px 0 0; width: 20%;">नवीन आला</td>
            <td colspan="1" style="border-width: 2px 2px 0 0;width: 20%;">एकूण रीम</td>
            <td colspan="1" style="border-width: 2px 2px 0 0; width: 20%;">या अंकाला <br> लागणारा पेपर</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 10%;">शिल्लक पेपर रीम</td>
        </tr>
        <tr *ngFor="let data of testdata">
            <td colspan="3" style="border-width: 2px 2px 0 2px; width: 5%; text-align: left; height: 40px;">{{ data['name'] }}</td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 20%; height: 40px;"></td>
            <td colspan="1" style="border-width: 2px 2px 0 0; width: 20%; height: 40px;"></td>
            <td colspan="1" style="border-width: 2px 2px 0 0; width: 20%; height: 40px;"></td>
            <td colspan="1" style="border-width: 2px 2px 0 0; width: 20%; height: 40px;"></td>
            <td colspan="2" style="border-width: 2px 2px 0 0; width: 10%; height: 40px;"></td>
        </tr>
        <tr>
            <td colspan="12" style="border-width: 2px 0 0 0; width: 100%;"></td>
        </tr>
    </table>

</div>
</div>